import { RequestSchemaRef } from 'pbts/c1/api/request_schema/v1/request_schema'
import { RequestSchemaServiceClient } from 'pbts/c1/api/request_schema/v1/request_schema.client'

import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'
import { createMutationApi } from './lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'

export const createRequestSchemaApi = createMutationApi(
    RequestSchemaServiceClient,
    'create',
    undefined,
    RequestSchemaRef.typeName,
)

export const updateRequestSchemaApi = createMutationApi(
    RequestSchemaServiceClient,
    'update',
    undefined,
    RequestSchemaRef.typeName,
)

export const createEntitlementBindingsApi = createMutationApi(
    RequestSchemaServiceClient,
    'createEntitlementBindings',
)

export const removeEntitlementBindingsApi = createMutationApi(
    RequestSchemaServiceClient,
    'removeEntitlementBindings',
)

export const getRequestSchemaApi = createUnaryApi(
    RequestSchemaServiceClient,
    'get',
    undefined,
    RequestSchemaRef.typeName,
)

export const findByAppEntitlementApi = createUnaryApi(
    RequestSchemaServiceClient,
    'findByAppEntitlement',
)

export const listRequestSchemasApi = createPagedListApi(
    RequestSchemaServiceClient,
    'list',
    undefined,
    RequestSchemaRef.typeName,
)

export const updateBindingsApi = createMutationApi(
    RequestSchemaServiceClient,
    'updateBindings',
)

export const findForAppEntitlementsApi = createUnaryApi(
    RequestSchemaServiceClient,
    'findForAppEntitlements',
)

export const countBindingsForSchemaApi = createUnaryApi(
    RequestSchemaServiceClient,
    'countBindingsForSchema',
)

export const deleteRequestSchemaApi = createMutationApi(
    RequestSchemaServiceClient,
    'delete',
    undefined,
    RequestSchemaRef.typeName,
)

export const searchRequestSchemasApi = createPagedListApi(
    RequestSchemaServiceClient,
    'search',
    undefined,
    RequestSchemaRef.typeName,
)
